import logo from "../../assets/images/Christian Brothers Horizontal_Green_RGB-01 (4).svg";
import { useMsal } from "@azure/msal-react";
import { Image, Flex, Divider, Progress, Button, Group } from "@mantine/core";
import { SignOutModal } from "../SignOutModal/SignOutModal";
import { StepperComponent } from "../Stepper/Stepper";
import { Paths } from "../../models/constants/paths.js";
import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalContext";
import { useMediaQuery } from "@mantine/hooks";
import "./LogoHeader.scss";

export const LogoHeader = () => {
  const { instance } = useMsal();
  let activeAccount = instance.getActiveAccount();
  
  const location = useLocation();
  const { context } = useContext(GlobalContext);
  const [stepperState, setStepperState] = useState(0);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [isInitialQuote, setIsInitialQuote] = useState(false);
  const [displayStepper, setDisplayStepper] = useState(false);
  const isMobile = useMediaQuery("(max-width: 1024px)", true, {
    getInitialValueInEffect: false,
  });

  useEffect(() => {
    switch (location.pathname) {
      case Paths.Questionnaire:
        setIsInitialQuote(true);
        setDisplayStepper(true);
        setStepperState(1);
        break;
      case Paths.FinalEstimatedQuote:
        setIsInitialQuote(true);
        setDisplayStepper(true);
        setStepperState(2);
        break;
      case Paths.ConfirmVehicle:
        setIsInitialQuote(false);
        setDisplayStepper(true);
        setStepperState(0);
        setProgressPercentage(0);
        break;
      case Paths.ConfirmDetails:
        setIsInitialQuote(false);
        setDisplayStepper(true);
        setStepperState(0);
        setProgressPercentage(16);
        break;
      case Paths.ConfirmAddress:
        setIsInitialQuote(false);
        setDisplayStepper(true);
        setStepperState(1);
        setProgressPercentage(33);
        break;
      case Paths.FinalQuote:
        setIsInitialQuote(false);
        setDisplayStepper(true);
        setStepperState(1);
        setProgressPercentage(50);
        break;
      case Paths.Agreements:
        setIsInitialQuote(false);
        setDisplayStepper(true);
        setStepperState(2);
        setProgressPercentage(67);
        if (localStorage.dviReviewStatus) {
          console.log(localStorage.dviReviewStatus);
        }
        break;
      case Paths.Payment:
        setIsInitialQuote(false);
        setDisplayStepper(true);
        setStepperState(3);
        setProgressPercentage(83);
        break;
      case Paths.Welcome:
        setIsInitialQuote(false);
        setDisplayStepper(true);
        setStepperState(4);
        setProgressPercentage(100);
        break;
      default:
        setDisplayStepper(false);
        break;
    }
  }, [location.pathname]);

  const displayHeaderButtons = () => {
    if (location.pathname === Paths.Welcome) {
      return (
        <div className="header-buttons centered">
          <Button
            className="header-button"
            component="a"
            href={`${process.env.REACT_APP_PORTAL_URL}/garage`}
            target="_blank"
            rel="noopener noreferrer"
            variant="filled"
            color="#006b5b"
            size={isMobile ? "xs" : "md"}
          >
            My Garage
          </Button>
          <Button
            className="header-button"
            component="a"
            href={`${process.env.REACT_APP_PORTAL_URL}/my-care-plus/${context?.vehicle_data?.vehicle_guid}`}
            target="_blank"
            rel="noopener noreferrer"
            variant="filled"
            color="#006b5b"
            size={isMobile ? "xs" : "md"}
          >
            My Care+ Details
          </Button>
          <SignOutModal />
        </div>
      );
    }

    return activeAccount ? (
      <div className="header-buttons">
        <SignOutModal />
      </div>
    ) : null;
  };

  return (
    <>
      <Flex justify="center" className="header-container">
        <Flex justify="space-between" align="center" className="logo-header" wrap="wrap">
          <Image
            className="headerStyle"
            radius="xs"
            fit="contain"
            src={logo}
          />
          {displayHeaderButtons()}
        </Flex>
      </Flex>
      {displayStepper ?
        <div className="full-container">
          <div className="content-container">
            <StepperComponent activeState={stepperState} isInitialQuote={isInitialQuote} />
            {isInitialQuote ? null : (
              <Progress.Root
                size={15}
                radius={"md"}
                transitionDuration={700}
                styles={{ root: { marginTop: "18px" } }}
              >
                <Progress.Section value={progressPercentage} color={"#006B5B"}>
                  <Progress.Label>{`${progressPercentage}%`}</Progress.Label>
                </Progress.Section>
              </Progress.Root>
            )}
          </div>
        </div>
        : null
      }
    </>
  );
};
